<template>
  <div class="index-container">
    <!-- 使用公共导航栏组件 -->
    <Nav />

    <!-- 轮播图区域 -->
    <section class="mt-20 relative overflow-hidden ">
      <div
        class="carousel-container relative h-96 lg:h-[500px]"
        ref="carouselContainer"
      >
        <div
          class="carousel-slide absolute inset-0"
          :class="{ active: ad.weigh == 1 }"
          :style="
            'background-image: url(' +
            ad.img_url +
            ');' +
            'background-size: cover;' +
            'background-position: center;'
          "
          v-for="(ad, index) in adList"
          :key="index"
        >
          <div class="absolute inset-0 bg-black bg-opacity-40"></div>
          <div
            class="relative z-10 h-full flex items-center justify-start px-6 max-w-7xl mx-auto"
          >
            <div class="max-w-2xl text-white text-left">
              <h1 class="text-4xl lg:text-5xl font-bold mb-4">
                {{ ad.title }}
              </h1>
              <p class="text-xl mb-8 opacity-90">
                {{ ad.description }}
              </p>
              <button
                class="bg-primary text-white px-8 py-3 !rounded-button hover:bg-secondary transition-colors text-lg whitespace-nowrap"
              >
                {{ ad.btntext }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- 轮播控制 -->
      <div
        class="absolute bottom-6 left-1/2 transform -translate-x-1/2 flex space-x-2"
      >
        <button
          class="carousel-dot active w-3 h-3 rounded-full bg-white opacity-50"
          :data-slide="index"
          v-for="(ad, index) in adList"
          :key="index"
          :class="{ active: ad.weigh == 1 }"
          @click="changeSlide(index)"
        ></button>
      </div>
    </section>
    <!-- 服务类别 -->
    <section class="py-16 px-6 lg:px-12">
      <div class="max-w-7xl mx-auto">
        <div class="text-center mb-12">
          <h2 class="text-3xl font-bold text-gray-900 mb-4">专业服务类别</h2>
          <p class="text-gray-600 text-lg">为您提供全方位的会展设备租赁服务</p>
        </div>
        <div class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6">
          <div class="service-category text-center group cursor-pointer">
            <div
              class="w-16 h-16 mx-auto mb-4 bg-blue-100 rounded-xl flex items-center justify-center group-hover:bg-primary transition-colors"
              @click="toCategory(3)"
            >
              <i
                class="ri-hammer-line text-2xl text-blue-600 group-hover:text-white"
              ></i>
            </div>
            <h3 class="text-lg font-semibold text-gray-900 mb-2">搭建材料</h3>
            <p class="text-gray-600 text-sm">
              展台搭建、背景板、展架等专业搭建材料
            </p>
          </div>
          <div class="service-category text-center group cursor-pointer">
            <div
              class="w-16 h-16 mx-auto mb-4 bg-blue-100 rounded-xl flex items-center justify-center group-hover:bg-primary transition-colors"
              @click="toCategory(1)"
            >
              <i
                class="ri-tv-line text-2xl text-blue-600 group-hover:text-white"
              ></i>
            </div>
            <h3 class="text-lg font-semibold text-gray-900 mb-2">视听设备</h3>
            <p class="text-gray-600 text-sm">
              投影仪、音响、LED 屏幕等高端视听设备
            </p>
          </div>
          <div class="service-category text-center group cursor-pointer">
            <div
              class="w-16 h-16 mx-auto mb-4 bg-blue-100 rounded-xl flex items-center justify-center group-hover:bg-primary transition-colors"
              @click="toCategory(2)"
            >
              <i
                class="ri-sofa-line text-2xl text-blue-600 group-hover:text-white"
              ></i>
            </div>
            <h3 class="text-lg font-semibold text-gray-900 mb-2">会展家具</h3>
            <p class="text-gray-600 text-sm">
              沙发、桌椅、展示柜等精品会展家具
            </p>
          </div>
          <div class="service-category text-center group cursor-pointer">
            <div
              class="w-16 h-16 mx-auto mb-4 bg-blue-100 rounded-xl flex items-center justify-center group-hover:bg-primary transition-colors"
              @click="toCategory(4)"
            >
              <i
                class="ri-gift-line text-2xl text-blue-600 group-hover:text-white"
              ></i>
            </div>
            <h3 class="text-lg font-semibold text-gray-900 mb-2">展示道具</h3>
            <p class="text-gray-600 text-sm">
              展示架、装饰品、互动道具等创意展示用品
            </p>
          </div>
          <div class="service-category text-center group cursor-pointer">
            <div
              class="w-16 h-16 mx-auto mb-4 bg-blue-100 rounded-xl flex items-center justify-center group-hover:bg-primary transition-colors"
              @click="toCategory(15)"
            >
              <i
                class="ri-game-line text-2xl text-blue-600 group-hover:text-white"
              ></i>
            </div>
            <h3 class="text-lg font-semibold text-gray-900 mb-2">暖场道具</h3>
            <p class="text-gray-600 text-sm">
              互动游戏、抽奖设备等活跃现场气氛道具
            </p>
          </div>
          <div class="service-category text-center group cursor-pointer">
            <div
              class="w-16 h-16 mx-auto mb-4 bg-blue-100 rounded-xl flex items-center justify-center group-hover:bg-primary transition-colors"
              @click="toCategory(16)"
            >
              <i
                class="ri-camera-line text-2xl text-blue-600 group-hover:text-white"
              ></i>
            </div>
            <h3 class="text-lg font-semibold text-gray-900 mb-2">摄影摄像</h3>
            <p class="text-gray-600 text-sm">
              专业摄影摄像设备，记录展会精彩时刻
            </p>
          </div>
        </div>
      </div>
    </section>

    <!-- 热门租赁产品 -->
    <section class="py-16 px-6 lg:px-12 bg-gray-50">
      <div class="max-w-7xl mx-auto">
        <div class="text-center mb-12">
          <h2 class="text-3xl font-bold text-gray-900 mb-4">热门租赁产品</h2>
          <p class="text-gray-600 text-lg">精选优质设备，满足您的各种需求</p>
        </div>
        <!-- 加载状态显示 -->
        <div v-if="loading" class="text-center py-12">
          <div
            class="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-primary"
          ></div>
          <p class="mt-4 text-gray-600">加载中...</p>
        </div>

        <!-- 无数据状态显示 -->
        <div
          v-else-if="hotProducts.length === 0"
          class="text-center py-12 bg-white rounded-xl shadow-sm"
        >
          <div
            class="w-24 h-24 mx-auto bg-gray-100 rounded-full flex items-center justify-center mb-4"
          >
            <i class="ri-inbox-line text-4xl text-gray-400"></i>
          </div>
          <h3 class="text-xl font-semibold text-gray-900 mb-2">暂无热门产品</h3>
          <p class="text-gray-600">敬请期待更多精彩产品</p>
        </div>

        <!-- 产品列表 -->
        <div v-else class="columns-1 md:columns-2 lg:columns-3 gap-6">
          <div
            v-for="product in hotProducts"
            :key="product.id"
            class="break-inside-avoid mb-6 bg-white rounded-xl shadow-sm overflow-hidden hover:shadow-lg transition-shadow group"
          >
            <div class="relative overflow-hidden">
              <!-- 图片加链接 -->
              <img
                :src="
                  product.thumbnail_url ||
                  'https://readdy.ai/api/search-image?query=rental+equipment+placeholder&width=400&height=300&orientation=landscape'
                "
                :alt="product.name"
                class="w-full h-56 object-cover object-top transition-transform duration-500 group-hover:scale-110 hover:cursor-pointer"
                @click="toGoodsDetail(product.id)"
              />
              <span
                class="absolute top-3 right-3 bg-primary text-white px-2 py-1 text-xs rounded"
                >{{ product.category_name || "设备" }}</span
              >
            </div>
            <div class="p-6">
              <h3
                class="text-xl font-semibold text-gray-900 mb-3 hover:text-primary cursor-pointer"
                @click="toGoodsDetail(product.id)"
              >
                {{ product.name }}
              </h3>
              <div class="text-sm text-gray-600 mb-4">
                <p class="leading-relaxed line-clamp-3">
                  {{ product.short_description || "暂无产品描述" }}
                </p>
              </div>
              <div class="flex items-center justify-between mb-4">
                <div class="flex items-center space-x-2">
                  <span class="text-2xl font-bold text-primary"
                    >¥{{ product.price || 0 }}</span
                  >
                  <span class="text-gray-500">/天</span>
                </div>
                <div
                  class="text-primary hover:text-secondary font-medium text-sm flex items-center"
                >
                  详情
                  <i class="ri-arrow-right-line ml-1"></i>
                </div>
              </div>

              <div class="flex space-x-3">
                <button
                  class="flex-1 bg-primary text-white py-2.5 !rounded-button hover:bg-secondary transition-colors whitespace-nowrap"
                  @click="handleAddToCart(product.id)"
                >
                  加入购物车
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 服务流程展示 -->
    <section class="py-16 px-6 lg:px-12 bg-gray-50">
      <div class="max-w-7xl mx-auto">
        <div class="text-center mb-12">
          <h2 class="text-3xl font-bold text-gray-900 mb-4">专业服务流程</h2>
          <p class="text-gray-600 text-lg">
            标准化服务流程，确保每个环节都精益求精
          </p>
        </div>
        <div class="relative">
          <div
            class="hidden lg:block absolute top-32 left-0 right-0 h-0.5"
          ></div>
          <div class="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-6 gap-6">
            <div class="relative group">
              <div class="flex flex-col items-center">
                <div
                  class="w-16 h-16 bg-white rounded-full border-2 border-primary flex items-center justify-center group-hover:bg-primary transition-colors duration-300 relative z-10"
                >
                  <i
                    class="ri-chat-3-line text-2xl text-primary group-hover:text-white"
                  ></i>
                </div>
                <div
                  class="absolute -right-3 top-7 w-6 h-6 text-gray-300 hidden lg:block"
                >
                  <i class="ri-arrow-right-line text-xl"></i>
                </div>
                <div class="mt-4 text-center">
                  <h3 class="text-lg font-semibold text-gray-900 mb-2">
                    需求沟通
                  </h3>
                  <p class="text-sm text-gray-600 mb-3">
                    了解客户需求，提供专业建议
                  </p>
                  <span
                    class="inline-block bg-blue-50 text-primary text-xs px-3 py-1 rounded-full"
                    >8:00 - 22:00</span
                  >
                </div>
              </div>
            </div>
            <div class="relative group">
              <div class="flex flex-col items-center">
                <div
                  class="w-16 h-16 bg-white rounded-full border-2 border-primary flex items-center justify-center group-hover:bg-primary transition-colors duration-300 relative z-10"
                >
                  <i
                    class="ri-file-text-line text-2xl text-primary group-hover:text-white"
                  ></i>
                </div>
                <div
                  class="absolute -right-3 top-7 w-6 h-6 text-gray-300 hidden lg:block"
                >
                  <i class="ri-arrow-right-line text-xl"></i>
                </div>
                <div class="mt-4 text-center">
                  <h3 class="text-lg font-semibold text-gray-900 mb-2">
                    询价报价
                  </h3>
                  <p class="text-sm text-gray-600 mb-3">个性化定制专属方案</p>
                  <span
                    class="inline-block bg-blue-50 text-primary text-xs px-3 py-1 rounded-full"
                    >3D效果图预览</span
                  >
                </div>
              </div>
            </div>
            <div class="relative group">
              <div class="flex flex-col items-center">
                <div
                  class="w-16 h-16 bg-white rounded-full border-2 border-primary flex items-center justify-center group-hover:bg-primary transition-colors duration-300 relative z-10"
                >
                  <i
                    class="ri-file-check-line text-2xl text-primary group-hover:text-white"
                  ></i>
                </div>
                <div
                  class="absolute -right-3 top-7 w-6 h-6 text-gray-300 hidden lg:block"
                >
                  <i class="ri-arrow-right-line text-xl"></i>
                </div>
                <div class="mt-4 text-center">
                  <h3 class="text-lg font-semibold text-gray-900 mb-2">
                    确认下单
                  </h3>
                  <p class="text-sm text-gray-600 mb-3">
                    签署服务协议，明确服务内容
                  </p>
                  <span
                    class="inline-block bg-blue-50 text-primary text-xs px-3 py-1 rounded-full"
                    >标准化合同</span
                  >
                </div>
              </div>
            </div>
            <div class="relative group">
              <div class="flex flex-col items-center">
                <div
                  class="w-16 h-16 bg-white rounded-full border-2 border-primary flex items-center justify-center group-hover:bg-primary transition-colors duration-300 relative z-10"
                >
                  <i
                    class="ri-tools-line text-2xl text-primary group-hover:text-white"
                  ></i>
                </div>
                <div
                  class="absolute -right-3 top-7 w-6 h-6 text-gray-300 hidden lg:block"
                >
                  <i class="ri-arrow-right-line text-xl"></i>
                </div>
                <div class="mt-4 text-center">
                  <h3 class="text-lg font-semibold text-gray-900 mb-2">
                    现场布置
                  </h3>
                  <p class="text-sm text-gray-600 mb-3">专业团队现场施工搭建</p>
                  <span
                    class="inline-block bg-blue-50 text-primary text-xs px-3 py-1 rounded-full"
                    >标准化施工</span
                  >
                </div>
              </div>
            </div>
            <div class="relative group">
              <div class="flex flex-col items-center">
                <div
                  class="w-16 h-16 bg-white rounded-full border-2 border-primary flex items-center justify-center group-hover:bg-primary transition-colors duration-300 relative z-10"
                >
                  <i
                    class="ri-customer-service-line text-2xl text-primary group-hover:text-white"
                  ></i>
                </div>
                <div
                  class="absolute -right-3 top-7 w-6 h-6 text-gray-300 hidden lg:block"
                >
                  <i class="ri-arrow-right-line text-xl"></i>
                </div>
                <div class="mt-4 text-center">
                  <h3 class="text-lg font-semibold text-gray-900 mb-2">
                    展会服务
                  </h3>
                  <p class="text-sm text-gray-600 mb-3">全程技术支持服务</p>
                  <span
                    class="inline-block bg-blue-50 text-primary text-xs px-3 py-1 rounded-full"
                    >一对一专人</span
                  >
                </div>
              </div>
            </div>
            <div class="relative group">
              <div class="flex flex-col items-center">
                <div
                  class="w-16 h-16 bg-white rounded-full border-2 border-primary flex items-center justify-center group-hover:bg-primary transition-colors duration-300 relative z-10"
                >
                  <i
                    class="ri-shield-check-line text-2xl text-primary group-hover:text-white"
                  ></i>
                </div>
                <div class="mt-4 text-center">
                  <h3 class="text-lg font-semibold text-gray-900 mb-2">
                    售后保障
                  </h3>
                  <p class="text-sm text-gray-600 mb-3">完善的售后服务体系</p>
                  <span
                    class="inline-block bg-blue-50 text-primary text-xs px-3 py-1 rounded-full"
                    >品质保证</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 案例展示区 -->
    <section class="py-16 px-6 lg:px-12">
      <div class="max-w-7xl mx-auto">
        <div class="text-center mb-12">
          <h2 class="text-3xl font-bold text-gray-900 mb-4">精彩案例展示</h2>
          <p class="text-gray-600 text-lg">
            见证我们的专业实力，感受卓越的服务品质
          </p>
        </div>
        <div class="masonry-grid columns-1 md:columns-2 lg:columns-3 gap-8">
          <div
            class="break-inside-avoid mb-8"
            v-for="item in caseshare"
            :key="item.id"
          >
            <div
              class="bg-white rounded-xl shadow-sm overflow-hidden hover:shadow-lg transition-shadow"
            >
              <img
                :src="item.thumbnail_url"
                alt="科技展案例"
                class="w-full object-cover object-top"
                @click="handleToDetail(item.id)"
              />
              <div class="p-6">
                <h3 class="text-lg font-semibold text-gray-900 mb-2">
                  {{ item.title }}
                </h3>
                <p class="text-gray-600 text-sm mb-4">
                  {{ item.description }}
                </p>
                <button
                  class="text-primary hover:text-secondary font-medium text-sm whitespace-nowrap"
                  @click="handleToDetail(item.id)"
                >
                  查看详情 →
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 客户评价与见证区 -->
    <section class="py-16 px-6 lg:px-12 bg-gray-50">
      <div class="max-w-7xl mx-auto">
        <div class="text-center mb-12">
          <h2 class="text-3xl font-bold text-gray-900 mb-4">客户评价与见证</h2>
          <p class="text-gray-600 text-lg">客户的满意是我们前进的动力</p>
        </div>
        <div class="testimonial-carousel relative overflow-hidden">
          <div class="testimonial-track flex transition-transform duration-500">
            <div class="testimonial-slide flex-shrink-0 w-full">
              <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                <div class="bg-white rounded-xl p-6 shadow-sm relative">
                  <div
                    class="absolute -top-2 -left-2 text-4xl text-primary opacity-20"
                  >
                    "
                  </div>
                  <div class="flex items-center mb-4">
                    <img
                      src="https://readdy.ai/api/search-image?query=Professional%20business%20woman%20portrait%2C%20corporate%20headshot%20with%20confident%20smile%2C%20modern%20office%20background&width=60&height=60&seq=avatar1&orientation=squarish"
                      alt="张雅琳"
                      class="w-12 h-12 rounded-full object-cover mr-4"
                    />
                    <div>
                      <h4 class="font-semibold text-gray-900">张雅琳</h4>
                      <p class="text-sm text-gray-600">华为技术有限公司</p>
                    </div>
                  </div>
                  <div class="flex mb-3">
                    <i class="ri-star-fill text-yellow-400"></i>
                    <i class="ri-star-fill text-yellow-400"></i>
                    <i class="ri-star-fill text-yellow-400"></i>
                    <i class="ri-star-fill text-yellow-400"></i>
                    <i class="ri-star-fill text-yellow-400"></i>
                  </div>
                  <p class="text-gray-600 text-sm">
                    服务非常专业，从方案设计到现场执行都很到位。设备质量优秀，技术支持及时，让我们的展会取得了圆满成功。强烈推荐！
                  </p>
                </div>
                <div class="bg-white rounded-xl p-6 shadow-sm relative">
                  <div
                    class="absolute -top-2 -left-2 text-4xl text-primary opacity-20"
                  >
                    "
                  </div>
                  <div class="flex items-center mb-4">
                    <img
                      src="https://readdy.ai/api/search-image?query=Professional%20businessman%20portrait%2C%20corporate%20executive%20headshot%20with%20suit%20and%20tie%2C%20modern%20office%20setting&width=60&height=60&seq=avatar2&orientation=squarish"
                      alt="李建国"
                      class="w-12 h-12 rounded-full object-cover mr-4"
                    />
                    <div>
                      <h4 class="font-semibold text-gray-900">李建国</h4>
                      <p class="text-sm text-gray-600">奔驰汽车中国</p>
                    </div>
                  </div>
                  <div class="flex mb-3">
                    <i class="ri-star-fill text-yellow-400"></i>
                    <i class="ri-star-fill text-yellow-400"></i>
                    <i class="ri-star-fill text-yellow-400"></i>
                    <i class="ri-star-fill text-yellow-400"></i>
                    <i class="ri-star-fill text-yellow-400"></i>
                  </div>
                  <p class="text-gray-600 text-sm">
                    合作了多次，每次都能超出预期。团队专业素养很高，设备先进，服务细致。是我们长期信赖的合作伙伴。
                  </p>
                </div>
                <div class="bg-white rounded-xl p-6 shadow-sm relative">
                  <div
                    class="absolute -top-2 -left-2 text-4xl text-primary opacity-20"
                  >
                    "
                  </div>
                  <div class="flex items-center mb-4">
                    <img
                      src="https://readdy.ai/api/search-image?query=Professional%20business%20woman%20portrait%2C%20marketing%20manager%20headshot%20with%20professional%20attire%2C%20corporate%20environment&width=60&height=60&seq=avatar3&orientation=squarish"
                      alt="王美华"
                      class="w-12 h-12 rounded-full object-cover mr-4"
                    />
                    <div>
                      <h4 class="font-semibold text-gray-900">王美华</h4>
                      <p class="text-sm text-gray-600">腾讯科技</p>
                    </div>
                  </div>
                  <div class="flex mb-3">
                    <i class="ri-star-fill text-yellow-400"></i>
                    <i class="ri-star-fill text-yellow-400"></i>
                    <i class="ri-star-fill text-yellow-400"></i>
                    <i class="ri-star-fill text-yellow-400"></i>
                    <i class="ri-star-fill text-yellow-400"></i>
                  </div>
                  <p class="text-gray-600 text-sm">
                    年会活动办得非常成功，现场效果震撼，员工反响热烈。从策划到执行都很专业，值得信赖的服务商。
                  </p>
                </div>
              </div>
            </div>
            <div class="testimonial-slide flex-shrink-0 w-full">
              <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                <div class="bg-white rounded-xl p-6 shadow-sm relative">
                  <div
                    class="absolute -top-2 -left-2 text-4xl text-primary opacity-20"
                  >
                    "
                  </div>
                  <div class="flex items-center mb-4">
                    <img
                      src="https://readdy.ai/api/search-image?query=Professional%20businessman%20portrait%2C%20senior%20executive%20headshot%20with%20glasses%2C%20corporate%20office%20background&width=60&height=60&seq=avatar4&orientation=squarish"
                      alt="陈志强"
                      class="w-12 h-12 rounded-full object-cover mr-4"
                    />
                    <div>
                      <h4 class="font-semibold text-gray-900">陈志强</h4>
                      <p class="text-sm text-gray-600">强生医疗</p>
                    </div>
                  </div>
                  <div class="flex mb-3">
                    <i class="ri-star-fill text-yellow-400"></i>
                    <i class="ri-star-fill text-yellow-400"></i>
                    <i class="ri-star-fill text-yellow-400"></i>
                    <i class="ri-star-fill text-yellow-400"></i>
                    <i class="ri-star-fill text-yellow-400"></i>
                  </div>
                  <p class="text-gray-600 text-sm">
                    医疗展的专业要求很高，他们的团队充分理解我们的需求，提供了完美的解决方案。展示效果非常棒！
                  </p>
                </div>
                <div class="bg-white rounded-xl p-6 shadow-sm relative">
                  <div
                    class="absolute -top-2 -left-2 text-4xl text-primary opacity-20"
                  >
                    "
                  </div>
                  <div class="flex items-center mb-4">
                    <img
                      src="https://readdy.ai/api/search-image?query=Professional%20business%20woman%20portrait%2C%20fashion%20industry%20executive%20headshot%2C%20stylish%20corporate%20setting&width=60&height=60&seq=avatar5&orientation=squarish"
                      alt="刘晓敏"
                      class="w-12 h-12 rounded-full object-cover mr-4"
                    />
                    <div>
                      <h4 class="font-semibold text-gray-900">刘晓敏</h4>
                      <p class="text-sm text-gray-600">香奈儿中国</p>
                    </div>
                  </div>
                  <div class="flex mb-3">
                    <i class="ri-star-fill text-yellow-400"></i>
                    <i class="ri-star-fill text-yellow-400"></i>
                    <i class="ri-star-fill text-yellow-400"></i>
                    <i class="ri-star-fill text-yellow-400"></i>
                    <i class="ri-star-fill text-yellow-400"></i>
                  </div>
                  <p class="text-gray-600 text-sm">
                    时尚展对美感要求极高，他们的设计团队很有创意，展示效果完美契合了我们的品牌调性。
                  </p>
                </div>
                <div class="bg-white rounded-xl p-6 shadow-sm relative">
                  <div
                    class="absolute -top-2 -left-2 text-4xl text-primary opacity-20"
                  >
                    "
                  </div>
                  <div class="flex items-center mb-4">
                    <img
                      src="https://readdy.ai/api/search-image?query=Professional%20businessman%20portrait%2C%20food%20industry%20executive%20headshot%20with%20friendly%20smile%2C%20modern%20corporate%20environment&width=60&height=60&seq=avatar6&orientation=squarish"
                      alt="赵文博"
                      class="w-12 h-12 rounded-full object-cover mr-4"
                    />
                    <div>
                      <h4 class="font-semibold text-gray-900">赵文博</h4>
                      <p class="text-sm text-gray-600">蒙牛乳业</p>
                    </div>
                  </div>
                  <div class="flex mb-3">
                    <i class="ri-star-fill text-yellow-400"></i>
                    <i class="ri-star-fill text-yellow-400"></i>
                    <i class="ri-star-fill text-yellow-400"></i>
                    <i class="ri-star-fill text-yellow-400"></i>
                    <i class="ri-star-fill text-yellow-400"></i>
                  </div>
                  <p class="text-gray-600 text-sm">
                    食品展的特殊需求他们都考虑得很周到，冷链设备专业可靠，现场服务也很到位。合作愉快！
                  </p>
                </div>
              </div>
            </div>
          </div>
          <!-- 轮播控制按钮 -->
          <button
            ref="testimonialPrev"
            class="testimonial-prev absolute left-4 top-1/2 transform -translate-y-1/2 w-10 h-10 bg-white shadow-lg rounded-full flex items-center justify-center hover:bg-gray-50 transition-colors"
          >
            <div class="w-5 h-5 flex items-center justify-center">
              <i class="ri-arrow-left-line text-gray-600"></i>
            </div>
          </button>
          <button
            ref="testimonialNext"
            class="testimonial-next absolute right-4 top-1/2 transform -translate-y-1/2 w-10 h-10 bg-white shadow-lg rounded-full flex items-center justify-center hover:bg-gray-50 transition-colors"
          >
            <div class="w-5 h-5 flex items-center justify-center">
              <i class="ri-arrow-right-line text-gray-600"></i>
            </div>
          </button>
        </div>
      </div>
    </section>

    <!-- 合作伙伴与品牌 -->
    <section class="py-16 px-6 lg:px-12">
      <div class="max-w-7xl mx-auto">
        <div class="text-center mb-12">
          <h2 class="text-3xl font-bold text-gray-900 mb-4">合作伙伴</h2>
          <p class="text-gray-600 text-lg">与众多知名企业建立长期合作关系</p>
        </div>
        <div class="partner-carousel overflow-hidden">
          <div
            class="partner-track flex items-center space-x-12 animate-scroll"
          >
            <div
              class="flex-shrink-0 w-32 h-20 flex items-center justify-center grayscale hover:grayscale-0 transition-all"
            >
              <div class="text-center">
                <div
                  class="w-8 h-8 mx-auto mb-1 flex items-center justify-center"
                >
                  <i class="ri-apple-fill text-2xl text-gray-400"></i>
                </div>
                <span class="text-sm text-gray-500 font-medium">Apple</span>
              </div>
            </div>
            <div
              class="flex-shrink-0 w-32 h-20 flex items-center justify-center grayscale hover:grayscale-0 transition-all"
            >
              <div class="text-center">
                <div
                  class="w-8 h-8 mx-auto mb-1 flex items-center justify-center"
                >
                  <i class="ri-microsoft-fill text-2xl text-gray-400"></i>
                </div>
                <span class="text-sm text-gray-500 font-medium">Microsoft</span>
              </div>
            </div>
            <div
              class="flex-shrink-0 w-32 h-20 flex items-center justify-center grayscale hover:grayscale-0 transition-all"
            >
              <div class="text-center">
                <div
                  class="w-8 h-8 mx-auto mb-1 flex items-center justify-center"
                >
                  <i class="ri-google-fill text-2xl text-gray-400"></i>
                </div>
                <span class="text-sm text-gray-500 font-medium">Google</span>
              </div>
            </div>
            <div
              class="flex-shrink-0 w-32 h-20 flex items-center justify-center grayscale hover:grayscale-0 transition-all"
            >
              <div class="text-center">
                <div
                  class="w-8 h-8 mx-auto mb-1 flex items-center justify-center"
                >
                  <i class="ri-amazon-fill text-2xl text-gray-400"></i>
                </div>
                <span class="text-sm text-gray-500 font-medium">Amazon</span>
              </div>
            </div>
            <div
              class="flex-shrink-0 w-32 h-20 flex items-center justify-center grayscale hover:grayscale-0 transition-all"
            >
              <div class="text-center">
                <div
                  class="w-8 h-8 mx-auto mb-1 flex items-center justify-center"
                >
                  <i class="ri-facebook-fill text-2xl text-gray-400"></i>
                </div>
                <span class="text-sm text-gray-500 font-medium">Meta</span>
              </div>
            </div>
            <div
              class="flex-shrink-0 w-32 h-20 flex items-center justify-center grayscale hover:grayscale-0 transition-all"
            >
              <div class="text-center">
                <div
                  class="w-8 h-8 mx-auto mb-1 flex items-center justify-center"
                >
                  <i class="ri-netflix-fill text-2xl text-gray-400"></i>
                </div>
                <span class="text-sm text-gray-500 font-medium">Netflix</span>
              </div>
            </div>
            <div
              class="flex-shrink-0 w-32 h-20 flex items-center justify-center grayscale hover:grayscale-0 transition-all"
            >
              <div class="text-center">
                <div
                  class="w-8 h-8 mx-auto mb-1 flex items-center justify-center"
                >
                  <i class="ri-tesla-fill text-2xl text-gray-400"></i>
                </div>
                <span class="text-sm text-gray-500 font-medium">Tesla</span>
              </div>
            </div>
            <div
              class="flex-shrink-0 w-32 h-20 flex items-center justify-center grayscale hover:grayscale-0 transition-all"
            >
              <div class="text-center">
                <div
                  class="w-8 h-8 mx-auto mb-1 flex items-center justify-center"
                >
                  <i class="ri-spotify-fill text-2xl text-gray-400"></i>
                </div>
                <span class="text-sm text-gray-500 font-medium">Spotify</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 使用公共页脚组件 -->
    <Footer />
  </div>
</template>

<script>
import Footer from "@/components/Footer.vue";
import Nav from "@/components/Nav.vue";
import api from "@/utils/api";
import { Message } from "element-ui";

export default {
  name: "Index",
  components: {
    Footer,
    Nav,
  },
  data() {
    return {
      // 热门租赁产品数据
      hotProducts: [],
      loading: false,
      // 案例数据
      caseshare: [],
      // 广告列表数据
      adList: [],
      // 轮播相关数据
      currentSlide: 0,
      carouselTimer: null,
      // 客户评价轮播相关数据
      currentTestimonial: 0,
      testimonialTimer: null,
    };
  },
  mounted() {
    // 加载热门租赁产品
    this.getHotProducts();
    // 初始化轮播功能
    this.initCarousel();
    // 初始化客户评价轮播
    this.initTestimonialCarousel();
    // 加载案例
    this.getCaseshare();
    // 加载广告列表
    this.getAdList();
  },

  beforeDestroy() {
    // 清理轮播定时器
    if (this.carouselTimer) {
      clearInterval(this.carouselTimer);
    }
    // 清理客户评价轮播定时器
    if (this.testimonialTimer) {
      clearInterval(this.testimonialTimer);
    }
  },
  methods: {
    // 获取热门租赁产品
    async getHotProducts() {
      try {
        this.loading = true;

        // 构建请求参数，获取热门产品
        // 使用销量排序来模拟热门产品
        const params = {
          page_current: 1,
          page_size: 6, // 获取6个热门产品
          sortBy: "sales_volume_desc", // 按销量降序排列
        };

        // 调用API获取设备列表
        const response = await api.goods.getList(params);

        // 处理返回的数据
        this.hotProducts = response.data.resdata || [];
      } catch (error) {
        console.error("获取热门产品失败:", error);
      } finally {
        this.loading = false;
      }
    },

    // 获取案例
    async getCaseshare() {
      try {
        // 构建请求参数，获取案例评价
        const params = {
          page_current: 1,
          page_size: 6, // 获取6个案例评价
        };

        // 调用API获取案例评价列表
        const response = await api.caseshare.getList(params);

        // 处理返回的数据
        this.caseshare = response.data.resdata || [];
      } catch (error) {
        console.error("获取案例失败:", error);
      }
    },

    // 获取广告列表
    async getAdList() {
      try {
        // 调用API获取广告列表
        const response = await api.index.getAdList();

        // 处理返回的数据
        this.adList = response.data || [];
      } catch (error) {
        console.error("获取广告列表失败:", error);
      }
    },

    // 处理跳转详情页
    handleToDetail(id) {
      this.$router.push({
        path: "/caseshare/" + id,
      });
    },

    // 初始化轮播功能
    initCarousel() {
      // 设置自动轮播
      this.startCarousel();

      // 添加指示器点击事件监听
      this.$nextTick(() => {
        const dots =
          this.$refs.carouselContainer.querySelectorAll(".carousel-dot") || [];
        dots.forEach((dot, index) => {
          dot.addEventListener("click", () => {
            this.goToSlide(index);
          });
        });
      });
    },

    // 开始自动轮播
    startCarousel() {
      this.carouselTimer = setInterval(() => {
        this.nextSlide();
      }, 5000); // 5秒切换一次
    },

    // 切换到上一张
    prevSlide() {
      const slides =
        this.$refs.carouselContainer.querySelectorAll(".carousel-slide") || [];
      this.currentSlide =
        (this.currentSlide - 1 + slides.length) % slides.length;
      this.updateSlide();
    },

    // 切换到下一张
    nextSlide() {
      const slides =
        this.$refs.carouselContainer.querySelectorAll(".carousel-slide") || [];
      this.currentSlide = (this.currentSlide + 1) % slides.length;
      this.updateSlide();
    },

    // 切换到指定幻灯片
    goToSlide(index) {
      this.currentSlide = index;
      this.updateSlide();
    },

    // 更新幻灯片显示
    updateSlide() {
      const slides =
        this.$refs.carouselContainer.querySelectorAll(".carousel-slide") || [];
      const dots =
        this.$refs.carouselContainer.querySelectorAll(".carousel-dot") || [];

      // 更新幻灯片显示
      slides.forEach((slide, index) => {
        if (index === this.currentSlide) {
          slide.classList.add("active");
        } else {
          slide.classList.remove("active");
        }
      });

      // 更新指示器状态
      dots.forEach((dot, index) => {
        if (index === this.currentSlide) {
          dot.classList.add("active");
          dot.style.opacity = "1";
        } else {
          dot.classList.remove("active");
          dot.style.opacity = "0.5";
        }
      });

      // 重置定时器
      if (this.carouselTimer) {
        clearInterval(this.carouselTimer);
        this.startCarousel();
      }
    },
    // 切换到指定幻灯片
    changeSlide(index) {
      this.currentSlide = index;
      this.updateSlide();
    },

    // 跳转到rent,post请求,并传递categoryIds参数
    toCategory(categoryId) {
      this.$router.push({
        name: "Rent",
        params: { categoryIds: categoryId },
      });
    },

    // 跳转到商品详情页
    toGoodsDetail(goodsId) {
      this.$router.push({
        name: "GoodsDetail",
        params: { id: goodsId },
      });
    },

    // 初始化客户评价轮播功能
    initTestimonialCarousel() {
      // 设置自动轮播
      this.startTestimonialCarousel();

      // 添加轮播控制按钮事件监听
      this.$nextTick(() => {
        this.$refs.testimonialPrev.addEventListener("click", () => {
          this.prevTestimonial();
        });
        this.$refs.testimonialNext.addEventListener("click", () => {
          this.nextTestimonial();
        });
      });
    },

    // 开始客户评价自动轮播
    startTestimonialCarousel() {
      this.testimonialTimer = setInterval(() => {
        this.nextTestimonial();
      }, 6000); // 6秒切换一次
    },

    // 切换到上一条客户评价
    prevTestimonial() {
      const testimonials = document.querySelectorAll(".testimonial-slide");
      this.currentTestimonial =
        (this.currentTestimonial - 1 + testimonials.length) %
        testimonials.length;
      this.updateTestimonial();
    },

    // 切换到下一条客户评价
    nextTestimonial() {
      const testimonials = document.querySelectorAll(".testimonial-slide");
      this.currentTestimonial =
        (this.currentTestimonial + 1) % testimonials.length;
      this.updateTestimonial();
    },

    // 更新客户评价显示
    updateTestimonial() {
      const track = document.querySelector(".testimonial-track");
      if (!track) return;

      // 使用transform实现平滑滑动过渡
      const slideWidth = -100 * this.currentTestimonial;
      track.style.transform = `translateX(${slideWidth}%)`;

      // 重置定时器
      if (this.testimonialTimer) {
        clearInterval(this.testimonialTimer);
        this.startTestimonialCarousel();
      }
    },

    // 添加到购物车
    async handleAddToCart(goodsId) {
      try {
        // 找到对应的商品信息
        const goods = this.hotProducts.find((item) => item.id === goodsId);

        if (!goods) {
          Message.error("商品信息获取失败");
          return;
        }

        // 构建商品数据
        const cartItem = {
          sku_id: goods.sku_id,
          name: goods.name,
          price: parseFloat(goods.price) || 0,
          quantity: 1,
          thumbnail_url: goods.thumbnail_url || "",
          supplier_name: goods.supplier_name || "未知供应商",
          supplier_id: goods.supplier_id || "1",
          short_description: goods.description || goods.short_description || "",
          goods_id: goods.id,
        };

        // 调用API添加商品到购物车
        const response = await api.goods.addToCart(cartItem);

        // 显示成功提示
        Message.success(`成功加入购物车`);
      } catch (error) {
        console.error("添加到购物车失败:", error);
      }
    },
  },
};
</script>

<style scoped>
/* 容器样式 */
.index-container {
  background-color: #ffffff;
}
.carousel-slide {
  opacity: 0;
  transition: opacity 0.5s ease-in-out;
}

.carousel-slide.active {
  opacity: 1;
}

/* 客户评价轮播样式 */
.testimonial-carousel {
  position: relative;
  overflow: hidden;
  width: 100%;
}

.testimonial-track {
  display: flex;
  transition: transform 0.8s cubic-bezier(0.25, 0.8, 0.25, 1);
  width: 100%;
}

.testimonial-slide {
  flex-shrink: 0;
  width: 100%;
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/pages/Index.vue